export default "https://d3fbpisbzpk8wt.cloudfront.net/2026512124252/receiptScanNgCrumpled-bundle-ec30db502e7aaac550666fa6a8cb6a07.png";